module.exports = __webpack_public_path__ + "img/muvelet9-dark.61e183a0.png";